import { resolveOktaAppsTruncationBanner } from "../../utils/oktaAppsTruncationBanner.js";

const TONE_CLASS = {
  amber: "border-amber-500/20 bg-amber-500/10 text-amber-100/95",
};

/**
 * @param {{ auditData?: unknown }} props
 */
export default function OktaAppsTruncationBanner({ auditData }) {
  const banner = resolveOktaAppsTruncationBanner(auditData);
  if (!banner) return null;

  const toneClass = TONE_CLASS[banner.tone] || TONE_CLASS.amber;

  return (
    <div className={`border-b px-4 py-2 text-center text-xs ${toneClass}`}>
      <span className="font-medium">{banner.message}</span> {banner.detail}
    </div>
  );
}
